import axios from "axios";
import { AuthHeader } from "./auth-header";
import { LogoutUser } from "../auth/auth-service";
import { toast } from "react-toastify";
import { messages } from "../../Messages";

const getMessage = messages.error;

const useHandle401Error = () => {
  LogoutUser()
  localStorage.clear();
  window.location.href = "/";
};

const AxiosRequest = {
  get: async (url: string): Promise<any> => {
    return axios
      .get(url, { headers: AuthHeader() })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            useHandle401Error()
          }
          if (error.response.status === 503) {
            toast.error(error.response.data.message)
          }
          return error
        } else {
          toast.error(getMessage.internal_server_error)
        }
      });
  },

  post: async (url: string, paylaod: any, headers: any = {}) => {
    return axios
      .post(url, paylaod, { headers: { ...AuthHeader(), ...(headers || {}) } })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            useHandle401Error()
          }
          return error
        } else {
          toast.error(getMessage.internal_server_error)
        }

      });
  },

  put: async (url: string, payload: any) => {
    return axios
      .put(url, payload, { headers: AuthHeader() })
      .then((response) => {
        return response;
      })
      .catch((error) => {

        if (error.response) {
          if (error.response.status === 401) {
            useHandle401Error()
          }
          return error
        } else {
          toast.error(getMessage.internal_server_error)
        }
      });
  },

  delete: async (url: string, payload: any = {}) => {
    return axios
      .delete(url, { headers: AuthHeader(), data: payload })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            useHandle401Error()
          }
          return error
        } else {
          toast.error(getMessage.internal_server_error)
        }
      });
  },
};
export { AxiosRequest };
